// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GVW4D","form":"styles_form__LiIbO","title":"styles_title__oB+TP","image":"styles_image__RvvM1"};